<template>
  <div>
    <md-dialog
      :class="modal == 'true' ? 'md-dialog-modal' : 'md-dialog-modal-none'"
      :md-active.sync="showDialog"
      :md-click-outside-to-close="false"
      v-resize="onResize"
    >
      <md-dialog-title v-if="!isPhotoTaken && is_camera_mode">
        Take a photo of the front of your ID
      </md-dialog-title>
      <md-dialog-title v-if="!isPhotoTaken && !is_camera_mode">
        Upload a photo of the front of your ID
      </md-dialog-title>
      <md-dialog-title v-if="isPhotoTaken && isCameraOpen"> Review Image</md-dialog-title>
      <md-dialog-content>
        <span v-if="!isPhotoTaken && is_camera_mode && !isPhotoUploaded">
          Use the camera on your device to take a photo of the front of your ID (or photo
          page If using passport). No camera?
          <strong @click="changetoupload"><u>Upload Images</u></strong>
        </span>
        <span v-if="!isPhotoTaken && !is_camera_mode && !isPhotoUploaded">
          Browse your device and upload a photo of the front of your ID or the photo page
          of your passport.
        </span>
        <span v-if="isPhotoTaken || isPhotoUploaded"
          >Is the image clear and can the text be read?</span
        >
        <div id="app" class="web-camera-container" v-if="is_camera_mode">
          <div v-show="isCameraOpen && isLoading" class="camera-loading">
            <ul class="loader-circle">
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <div>
            <v-easy-camera
              v-if="isCameraOpen"
              v-show="!isLoading"
              :autoDetectMobile="false"
              ref="picpreview"
              style="padding: 10px"
            ></v-easy-camera>
          </div>
          <div v-if="isCameraOpen && !isLoading" class="camera-shoot text-center">
            <button
              type="button"
              class="button"
              style="border-radius: 30px; margin-left: 60px"
              @click="takePhoto"
              v-if="!isPhotoTaken"
            >
              <img
                src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png"
              />
            </button>
            <button
              type="button"
              class="button"
              style="border-radius: 30px; width: 40px; height: 40px; margin-left: 10px"
              @click="switchCamera"
              v-if="!isPhotoTaken"
            >
              <img src="@/assets/switchCamera.png" />
            </button>
          </div>
          <div v-if="isPhotoTaken && isCameraOpen" class="camera-download text-center">
            <md-progress-spinner
              v-if="showDownSpinner"
              md-mode="indeterminate"
            ></md-progress-spinner>
            <md-button
              id="downloadPhoto"
              download="my-photo.jpg"
              role="button"
              class="md-raised md-primary"
              v-if="isPhotoTaken && isCameraOpen && !showDownSpinner"
              @click="downloadImage()"
              >Looks good</md-button
            >
          </div>
          <div class="text-center">
            <md-button
              class="md-raised"
              v-if="isPhotoTaken && isCameraOpen && !showDownSpinner"
              @click="takePhoto"
              >re-take photo</md-button
            >
          </div>
        </div>

        <div v-if="!is_camera_mode" :class="!isPhotoUploaded ? 'upload-card' : ''">
          <div class="text-center" v-if="!isPhotoUploaded">
            <span>Front of your ID document<br />(or photo page of passport)</span>
          </div>
          <div class="text-center upload_button">
            <image-upload
              v-if="!isPhotoUploaded"
              class="btn btn-primary"
              post-action="/upload/post"
              extensions="gif,jpg,jpeg,png,webp"
              accept="image/png,image/gif,image/jpeg,image/webp"
              :multiple="true"
              :size="1024 * 1024 * 10"
              :quality="0.7"
              :maxWidth="1920"
              @input-filter="inputFilter"
              @input-file="inputFile"
              ref="upload"
              v-model="files"
            >
              <i class="fa fa-plus"></i>
              choose file...
            </image-upload>
            <canvas
              v-if="isPhotoUploaded"
              id="uploadedcanvas"
              ref="uploadedcanvas"
              v-bind:width="cwidth"
              v-bind:height="cheight"
              :quality="0.7"
              :maxWidth="1920"
            ></canvas>
          </div>
          <div v-if="isPhotoUploaded" class="camera-download text-center">
            <md-progress-spinner
              v-if="isPhotoUploaded && showUploadSpinner"
              md-mode="indeterminate"
            ></md-progress-spinner>
            <md-button
              id="downloadPhoto"
              download="my-photo.jpg"
              role="button"
              class="md-raised md-primary"
              v-if="isPhotoUploaded && !showUploadSpinner"
              @click="UploadImage()"
              >Looks good</md-button
            >
          </div>
          <div class="text-center">
            <md-button
              class="md-raised"
              v-if="isPhotoUploaded && !showUploadSpinner"
              @click="return_upload()"
              >re-take photo</md-button
            >
          </div>
        </div>

        <div class="footer">
          <img class="logo-size" src="@/assets/logo.png" />
          <div class="form-check mt-3" v-if="!isPhotoTaken && !isPhotoUploaded">
            <input
              class="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault1"
              @click="changetocamera"
              v-model="Tab_type"
              value="A"
            />
            <label class="form-check-label" for="flexRadioDefault1"> Use Camera </label>
          </div>
          <div class="form-check mt-3" v-if="!isPhotoTaken && !isPhotoUploaded">
            <input
              class="form-check-input"
              type="radio"
              name="flexRadioDefault"
              id="flexRadioDefault2"
              @click="changetoupload"
              v-model="Tab_type"
              value="B"
            />
            <label class="form-check-label" for="flexRadioDefault2">
              Upload Images
            </label>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import ImageUpload from "vue-upload-component";
import axios from "axios";
import EasyCamera from "easy-vue-camera";
export default {
  name: "VerifyCapture",
  mixins: [validationMixin],

  components: {
    ImageUpload,
    "v-easy-camera": EasyCamera,
  },

  props: {
    msg: String,
  },

  data: () => ({
    files: [],
    showDialog: true,
    form: {
      sixcode: null,
    },
    isCameraOpen: true,
    isPhotoTaken: false,
    isShotPhoto: false,
    isLoading: false,
    link: "#",
    is_camera_mode: true,
    is_uploaded: false,
    Tab_type: "A",
    session_key: "",
    modal: "",
    idtype: "",
    isPhotoUploaded: false,
    uploadcontext: "",
    uploaded_data: "",
    photo_data: "",
    showDownSpinner: false,
    showUploadSpinner: false,
    Session: {},
    cwidth: 450,
    cheight: 450,
    vwidth: 450,
    vheight: 450,
    face: "user",
  }),
  watch: {
    "$refs.Uploadedcanvas": function (currentValue) {
      console.log(currentValue);
      this.uploadcontext = this.$refs.Uploadedcanvas.getContext("2d");
    },
  },
  methods: {
    uploaded_photo() {
      console.log("uploaded_canvas");
    },
    UploadImage() {
      this.showUploadSpinner = true;
      axios
        .post("/api/session/" + this.session_key + "/file", {
          contentType: "image/octet-stream",
          content: this.uploaded_data.split(";base64,")[1],
          fileType: this.idtype,
          fileAngle: "Front",
        })
        .then((response) => {
          console.log(response);
          this.$router.push({
            name: "VerifyCaptureFace",
            params: {
              session_key: this.session_key,
              idtype: this.idtype,
              modal: this.modal,
              session: this.Session,
            },
          });
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({
            name: "HandleError",
            params: {
              session: this.Session,
              type: "",
              modal: this.modal,
            },
          });
        });
    },
    return_upload() {
      this.isPhotoUploaded = false;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    async inputFile(newFile, oldFile) {
      this.isPhotoUploaded = true;
      const FLASH_TIMEOUT = 50;
      await setTimeout(() => {
        this.isShotPhoto = false;
      }, FLASH_TIMEOUT);

      this.uploadcontext = this.$refs.uploadedcanvas.getContext("2d");

      if (newFile && !oldFile) {
        // add
        var image = new Image();
        var _this = this;

        image.onload = async function () {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          _this.cwidth = 450;
          _this.cheight = 450;
          canvas.width = image.width;
          canvas.height = image.height;
          if (canvas.width > 1920) {
            canvas.height = (1920 * canvas.height) / canvas.width;
            canvas.width = 1920;
          }
          if (canvas.height > 1920) {
            canvas.width = (1920 * canvas.width) / canvas.height;
            canvas.height = 1920;
          }
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          _this.uploaded_data = canvas.toDataURL("image/jpeg", 0.7);
          if (canvas.width > canvas.height) {
            _this.cheight = (_this.cheight * canvas.height) / canvas.width;
          } else {
            _this.cwidth = (_this.cwidth * canvas.width) / canvas.height;
          }

          const FLASH_TIMEOUT = 50;
          await setTimeout(() => {
            this.isShotPhoto = false;
          }, FLASH_TIMEOUT);
          _this.uploadcontext.drawImage(image, 0, 0, _this.cwidth, _this.cheight);
        };
        var reader = new FileReader();
        reader.readAsDataURL(newFile.file);
        reader.onload = () => {
          image.src = reader.result;
        };
      }
      if (newFile && oldFile) {
        // update
        console.log("update", newFile);
      }
      if (!newFile && oldFile) {
        // remove
        console.log("remove", oldFile);
      }
    },
    changetocamera() {
      this.is_camera_mode = true;
      this.Tab_type = "A";
    },
    changetoupload() {
      this.is_camera_mode = false;
      this.Tab_type = "B";
    },
    go_modal4() {
      this.$router.push({ name: "privacypolicy" });
    },

    switchCamera() {
      this.$refs.picpreview.switchCamera();
    },

    async takePhoto() {
      this.$refs.picpreview.snap();
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      } else {
        this.$refs.picpreview.start();
      }
      this.isPhotoTaken = !this.isPhotoTaken;
    },

    downloadImage() {
      this.showDownSpinner = true;
      let cid = this.$refs.picpreview.refCameraComponent.canvasElementId;
      const canvas = document
        .getElementById(cid)
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream");
      axios
        .post("/api/session/" + this.session_key + "/file", {
          contentType: "image/octet-stream",
          content: canvas.split(";base64,")[1],
          fileType: this.idtype,
          fileAngle: "Front",
        })
        .then((response) => {
          console.log(response);
          this.$router.push({
            name: "VerifyCaptureFace",
            params: {
              session_key: this.session_key,
              idtype: this.idtype,
              modal: this.modal,
              session: this.Session,
            },
          });
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({
            name: "HandleError",
            params: {
              session: this.Session,
              type: "",
              modal: this.modal,
            },
          });
        });
    },
    onResize({ width, height }) {
      window.onResizeHandler(width, height);
    },
  },

  mounted() {
    this.session_key = this.$route.params.session_key;
    this.modal = this.$route.params.modal;
    this.idtype = this.$route.params.idtype;
    this.Session = this.$route.params.session;
    if (this.session_key == null) {
      const _this = this;
      this.$router.push({
        name: "HandleError",
        params: {
          session: _this.Session,
          type: "notSession",
        },
      });
    }
  },
};
</script> 

<style lang="scss" scoped>
.upload-card {
  margin: 10%;
  padding: 50px;
  // border: 2px dotted #8c8282;
  border-radius: 10px;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='30' ry='30' stroke='%23333' stroke-width='3' stroke-dasharray='10' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e");
  border-radius: 30px;
}

.footer {
  display: flex;
  justify-content: space-between;
}

.logo-size {
  width: 150px;
}

.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  background-color: #73c773;
  border-radius: 10px;
  padding-left: 70px;
  padding-right: 70px;
  color: white !important;
}

.md-dialog-actions {
  justify-content: center;
  padding: 8px !important;
}
.btn-element {
  margin: 1% !important;
  color: black !important;
  font-size: 12px;
}
ul {
  margin-top: 1rem !important;
  margin-bottom: 0rem !important;
}
.md-dialog-modal-none {
  right: unset;
  bottom: unset;
  z-index: 1;
  ::v-deep .md-dialog-container {
    box-shadow: none;
    max-width: 100%;
  }
}

.md-dialog-modal {
  z-index: 1;
  ::v-deep .md-dialog-container {
    max-width: 500px;
    border-radius: 20px !important;
    border: 3px solid black;
  }
}

.camera-box {
  padding: 30px;
}
#photoTaken {
  border-radius: 10px;
  width: 400px;
}
.btn-primary {
  color: #fff;
  background-color: #73c773;
  border-color: #73c773;
  padding-left: 50px;
  padding-right: 50px;
  font-size: 15px;
  border-radius: 16px;
}
.upload_button {
  padding-top: 20px;
}
</style>